export default "__VITE_ASSET__86f6ede6__"